import { createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/layout/heading";

export const Route = createFileRoute("/dashboard/_layout/market-tracker")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <PageHeader title="Market Tracker" description="Track market trends and insights" className="mb-8" />
      <div className="rounded-lg border border-dashed bg-muted/30 p-8 text-center text-muted-foreground">Market tracker content coming soon.</div>
    </div>
  );
}
